module.exports = __webpack_public_path__ + "static/img/au.2a1384d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/au.png
// module id = 1sqK
// module chunks = 18